<section class="sec" id="how">
  <div class="wrap">
    <div class="sec-head" appReveal>
      <span class="kicker">How It Works</span>
      <h2>See ConnectNow in action</h2>
      <p>Let AI handle routine queries while agents focus on complex needs — effortlessly, intelligently, and customer-centric.</p>
    </div>
    <div class="steps">
      <div class="step" appReveal>
        <div class="num">01</div>
        <div class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 3a4 4 0 014 4v3a4 4 0 01-8 0V7a4 4 0 014-4zM6 11a6 6 0 0012 0M12 17v3M8 21h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></div>
        <h3>AI Agent Handles Initial Call</h3>
        <p>Interactions are first handled by AI agents that provide consistent, reliable help for sales queries plus automated task completion for service needs.</p>
      </div>
      <div class="step" appReveal>
        <div class="num">02</div>
        <div class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 8l5-3v14l-5-3M3 6h12v12H3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></div>
        <h3>Audio &amp; Video Options</h3>
        <p>Multi-modal omnichannel interactions. Meet customers where and how they want to meet you: AI agents, Video, Call or Chat.</p>
      </div>
      <div class="step" appReveal>
        <div class="num">03</div>
        <div class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 7a4 4 0 118 0 4 4 0 01-8 0zM16 7a4 4 0 100 0M3 21a6 6 0 0112 0M14 21a6 6 0 016-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></div>
        <h3>Effortless Handoff to Humans</h3>
        <p>If an AI agent identifies a complex or unique request, it seamlessly brings a live agent into the conversation.</p>
      </div>
      <div class="step" appReveal>
        <div class="num">04</div>
        <div class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></div>
        <h3>Rich Customer Analytics</h3>
        <p>Track every interaction to harness valuable insights and analytics that help you understand and scale your business.</p>
      </div>
    </div>
  </div>
</section>
